import { render } from "./DashboardEntrainView.vue?vue&type=template&id=01c84d08"
import script from "./DashboardEntrainView.vue?vue&type=script&lang=js"
export * from "./DashboardEntrainView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__